import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetGrammarProgressV1Response } from './get-grammar-progress-v1-response';
import { getGrammarProgressV1ResponseSchema } from './get-grammar-progress-v1-response';

export async function getGrammarProgressV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetGrammarProgressV1Response>> {
  return getRequest<IGetGrammarProgressV1Response>({
    path: '/grammar/progress/v1',
    schema: getGrammarProgressV1ResponseSchema,
    options,
  });
}
